import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";

import ComponentOnImage from "../components/ComponentOnImage";
import LoginForm from "../components/LoginForm";
import StepsNotification from "../components/StepsNotification";
import { loginUserRequest } from "../redux/actions";
import { AppState } from "../redux/types";
import { localePath, getSlug, getLocaleFromPath } from "../i18n/config";
import { metadataTranslations } from "../i18n/metadata";
import { CATEGORIES, categoryOptions } from "../utils/constants";

// import { Image, Container } from 'react-bootstrap'
// import underContruction from '../images/under-construction.jpg'

const Login = () => {
    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const rawCategory = useSelector((state: AppState) => state.categories.category?.attributes.slug);
    const category = CATEGORIES[rawCategory as keyof typeof CATEGORIES] || rawCategory;

    const dispatch = useDispatch();
    const history = useHistory();

    const user = useSelector((state: AppState) => state.user);
    const selectedServices = useSelector((state: AppState) => state.cart.inCart);
    const { loading, error, id } = user;

    const locale = getLocaleFromPath();
    const meta = metadataTranslations.login[locale] || metadataTranslations.login.fi;

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        const redirect = selectedServices.length > 0 ? (category !== categoryOptions.app ? localePath("toimitus") : localePath("osta") + "/" + getSlug("videopuhelu_appi", getLocaleFromPath(""))) : undefined;
        const trimmedUsername = (username ?? "").trim();
        const trimmedPassword = (password ?? "").trim();

        dispatch(loginUserRequest(trimmedUsername, trimmedPassword, redirect, history));
        setUserName("");
        setPassword("");
    };

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
            </Helmet>
            {/* <Container>
        <Image
          src={`${underContruction}`}
          style={{
            height: '600px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 'auto',
          }}
        ></Image>
      </Container> */}
            {/* TODO: fix */}
            <ComponentOnImage
                width="100vw"
                backgroundRepeat="no-repeat"
                backgroundSize="cover"
                backgroundImage={"https://senioritabletti-image-bucket.s3.eu-north-1.amazonaws.com/woman.jpg"}
                className="login-page-form-on-image"
                imgClassName="login-woman"
                component={<LoginForm submitHandler={submitHandler} error={error} username={username} setUserName={setUserName} password={password} setPassword={setPassword} loading={loading} id={id} />}
            />
            {selectedServices.length !== 0 && <StepsNotification />}
        </>
    );
};

export default Login;
